import { EmailRegex } from '@utilities/regex.utilities';
import { DomainInvalidPayloadError } from '@core/shared/errors';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { AccountActivationResponse, ActivateAccountRequestPayload, IRequestAccountActivationUseCase } from '../../interfaces';

export default class RequestAccountActivationUseCase extends HttpPostRequest<ActivateAccountRequestPayload, AccountActivationResponse> implements IRequestAccountActivationUseCase {
  static readonly INVALID_RECAPTCHA_TOKEN = 'INVALID_RECAPTCHA_TOKEN';
  static readonly INVALID_FISCAL_ID_OR_EMAIL = 'INVALID_FISCAL_ID_OR_EMAIL';

  async execute(payload: ActivateAccountRequestPayload): Promise<AccountActivationResponse> {
    this.validatePayload(payload);
    return (await this.dispatch('/auth/request-activation', payload)).data.data;
  }

  private validatePayload(payload: ActivateAccountRequestPayload): void {
    if (payload.captchaToken === '') throw new DomainInvalidPayloadError(RequestAccountActivationUseCase.INVALID_RECAPTCHA_TOKEN);
    else if (payload.fiscalId === '' || !EmailRegex.test(payload.email)) throw new DomainInvalidPayloadError(RequestAccountActivationUseCase.INVALID_FISCAL_ID_OR_EMAIL);
  }
}
